module.exports = __webpack_public_path__ + "static/media/400168_01.11880ddb.png";